import React from 'react';

import Header from '../components/Header';
import Background from '../components/Background';
import Footer from '../components/Footer';

export default function Terms() {
    return (
        <>
            <Header />
            <Background />

            <Footer />
        </>
    )
}